const baseUrl = "http://120.55.169.187:8881";  //登录 注册
export default {
  baseUrl,
};



// WEBPACK FOOTER //
// ./src/assets/api.js